var map = {
	"./category_1.svg": "0962",
	"./category_2.svg": "effa",
	"./category_3.svg": "e3cb",
	"./category_4.svg": "9c2e",
	"./category_5.svg": "ca99",
	"./category_6.svg": "3901",
	"./category__2.svg": "ff4a",
	"./category__5.svg": "0791"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e8c";